import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'home' },

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'forgot-password', loadChildren: () => import('app/pages/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule) },
            { path: 'reset-password', loadChildren: () => import('app/pages/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule) },
            { path: 'sign-in', loadChildren: () => import('app/pages/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },
            { path: 'authen', loadChildren: () => import('app/pages/auth/authen/authen.module').then(m => m.SignAuthenModule) },
            // {path: 'sign-up', loadChildren: () => import('app/pages/auth//sign-up/sign-up.module').then(m => m.AuthSignUpModule)}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/pages/auth//sign-out/sign-out.module').then(m => m.AuthSignOutModule) },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            { path: 'home', loadChildren: () => import('app/pages/home/home.module').then(m => m.HomeModule) },
            { path: 'my-related-law', loadChildren: () => import('app/pages/my-related-law/my-related-law.module').then(m => m.MyRelatedLawModule) },
            {
                path: 'my-related-law', children: [
                    { path: 'law-assessment', loadChildren: () => import('app/pages/my-related-law/law-assessment/law-assessment.module').then(m => m.LawAssessmentModule) },
                ]
            },
            { path: 'my-responsibility', loadChildren: () => import('app/pages/my-responsibility/my-responsibility.module').then(m => m.MyResponsibilityModule) },
            { path: 'extend-certificate', loadChildren: () => import('app/pages/extend-certificate/extend-certificate.module').then(m => m.ExtendCertificateModule) },
            {
                path: 'extend-certificate', children: [
                    { path: 'extend-certificate-plan', loadChildren: () => import('app/pages/extend-certificate/extend-certificate-plan/extend-certificate-plan.module').then(m => m.ExtendCertificatePlanModule) },
                    { path: 'view-plan-detail', loadChildren: () => import('app/pages/extend-certificate/view-plan-detail/view-plan-detail.module').then(m => m.ViewPlanDetailModule) },
                ]
            },
            { path: 'approval-plan', loadChildren: () => import('app/pages/approval-plan/approval-plan.module').then(m => m.ApprovalPlanModule) },
            {
                path: 'approval-plan', children: [
                    { path: 'approval-plan-detail', loadChildren: () => import('app/pages/approval-plan/approval-plan-detail/approval-plan-detail.module').then(m => m.ApprovalPlanDetailModule) },
                ]
            },
            { path: 'update-progress', loadChildren: () => import('app/pages/update-progress/update-progress.module').then(m => m.UpdateProgressModule) },
            {
                path: 'update-progress', children: [
                    { path: 'update-progress-detail', loadChildren: () => import('app/pages/update-progress/update-progress-detail/update-progress-detail.module').then(m => m.UpdateProgressDetailModule) },
                    { path: 'update-document-detail', loadChildren: () => import('app/pages/update-progress/update-document-detail/update-document-detail.module').then(m => m.UpdateDocumentDetailModule) },
                ]
            },
            { path: 'review-plan', loadChildren: () => import('app/pages/review-plan/review-plan.module').then(m => m.ReviewPlanModule) },
            {
                path: 'review-plan', children: [
                    { path: 'review-plan-detail', loadChildren: () => import('app/pages/review-plan/review-plan-detail/review-plan-detail.module').then(m => m.ReviewPlanDetailModule) },
                ]
            },
            {
                path: 'search', children: [
                    { path: 'view-law-regulation', loadChildren: () => import('app/pages/search/view-law-regulation/view-law-regulation.module').then(m => m.ViewLawRegulationModule) },
                    { path: 'view-certificate', loadChildren: () => import('app/pages/search/view-certificate/view-certificate.module').then(m => m.ViewCertificateModule) },
                    { path: 'view-responsibility-person', loadChildren: () => import('app/pages/search/view-responsibility-person/view-responsibility-person.module').then(m => m.ViewResponsibilityPersonModule) },
                ]
            },
            { path: 'news-activity', loadChildren: () => import('app/pages/news-activity/news-activity.module').then(m => m.NewsActivityModule) },
            {
                path: 'news-activity', children: [
                    { path: 'news-activity-detail', loadChildren: () => import('app/pages/news-activity/news-activity-detail/news-activity-detail.module').then(m => m.NewsActivityDetailModule) },
                ]
            },
            { path: 'about-us', loadChildren: () => import('app/pages/about-us/about-us.module').then(m => m.AboutUsModule) },
            { path: 'report', loadChildren: () => import('app/pages/report/report.module').then(m => m.ReportModule) },
            {
                path: 'report', children: [
                    { path: 'summary-report', loadChildren: () => import('app/pages/report/summary-report/summary-report.module').then(m => m.SummaryReportModule) },
                    { path: 'law-registration-report', loadChildren: () => import('app/pages/report/law-registration-report/law-registration-report.module').then(m => m.LawRegistrationReportModule) },
                    { path: 'law-enforcement-report', loadChildren: () => import('app/pages/report/law-enforcement-report/law-enforcement-report.module').then(m => m.LawEnforcementReportModule) },
                    { path: 'law-assessment-report', loadChildren: () => import('app/pages/report/law-assessment-report/law-assessment-report.module').then(m => m.LawAssessmentReportModule) },
                ],
            },
            {
                path: 'administrator', children: [
                    { path: 'manage-law-regulation', loadChildren: () => import('app/pages/administrator/manage-law-regulation/manage-law-regulation.module').then(m => m.ManageLawRegulationModule) },
                    { path: 'manage-certificate', loadChildren: () => import('app/pages/administrator/manage-certificate/manage-certificate.module').then(m => m.ManageCertificateModule) },
                    {
                        path: 'manage-certificate', children: [
                            { path: 'manage-certificate-relevant-laws', loadChildren: () => import('app/pages/administrator/manage-certificate/manage-certificate-relevant-laws/manage-certificate-relevant-laws.module').then(m => m.ManageCertificateRelevantLawModule) },
                            { path: 'manage-responsibility-person', loadChildren: () => import('app/pages/administrator/manage-certificate/manage-responsibility-person/manage-responsibility-person.module').then(m => m.ManageResponsibilityModule) },
                        ]
                    },
                    { path: 'manage-user', loadChildren: () => import('app/pages/administrator/manage-user/manage-user.module').then(m => m.ManageUserModule) },
                    { path: 'manage-news-activity', loadChildren: () => import('app/pages/administrator/manage-news-activity/manage-news-activity.module').then(m => m.ManageNewsActivityModule) },
                    { path: 'manage-about-us', loadChildren: () => import('app/pages/administrator/manage-about-us/manage-about-us.module').then(m => m.ManageAboutUsModule) },
                    { path: 'manage-certificate-relevant-laws', loadChildren: () => import('app/pages/administrator/manage-certificate/manage-certificate-relevant-laws/manage-certificate-relevant-laws.module').then(m => m.ManageCertificateRelevantLawModule) }

                ]
            },

        ]
    }
];
